var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-collapse', {
    staticStyle: {
      "width": "92%",
      "margin-left": "4%",
      "border": "1px solid #EBEEF5",
      "height": "400px"
    },
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.organizeList), function(item) {
    return _c('el-collapse-item', {
      key: item.id
    }, [_c('template', {
      slot: "title"
    }, [_c('el-row', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('el-col', {
      staticStyle: {
        "padding-top": "2px"
      },
      attrs: {
        "span": 1,
        "offset": 1
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../assets/icon/迈亚集团icon@2x.png")
      }
    })]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 10
      }
    }, [_c('span', [_vm._v(_vm._s(item.organize_name))])])], 1)], 1), _vm._v(" "), _c('div', [_c('el-collapse', _vm._l((item.organizeList), function(item2) {
      return _c('el-collapse-item', {
        key: item2.id
      }, [_c('template', {
        slot: "title"
      }, [_c('el-row', {
        staticStyle: {
          "width": "100%",
          "padding-left": "5px"
        }
      }, [_c('el-col', {
        staticStyle: {
          "padding-top": "2px"
        },
        attrs: {
          "span": 1,
          "offset": 2
        }
      }, [_c('img', {
        attrs: {
          "src": require("../../../assets/icon/icon2灰@2x.png")
        }
      })]), _vm._v(" "), _c('el-col', {
        attrs: {
          "span": 10
        }
      }, [_c('span', [_vm._v(_vm._s(item2.organize_name))])])], 1)], 1), _vm._v(" "), _c('div', [_c('el-collapse', {
        model: {
          value: (_vm.project_id),
          callback: function($$v) {
            _vm.project_id = $$v
          },
          expression: "project_id"
        }
      }, _vm._l((item2.projectList), function(item3) {
        return _c('el-collapse-item', {
          key: item3.id,
          attrs: {
            "name": item3.id
          }
        }, [_c('template', {
          slot: "title"
        }, [_c('el-row', {
          staticStyle: {
            "width": "100%",
            "padding-left": "10px"
          }
        }, [_c('el-col', {
          staticStyle: {
            "padding-top": "2px"
          },
          attrs: {
            "span": 1,
            "offset": 3
          }
        }, [_c('img', {
          attrs: {
            "src": require("../../../assets/icon/icon2灰@2x.png")
          }
        })]), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 10
          }
        }, [_c('span', [_vm._v(_vm._s(item3.project_name))])])], 1)], 1), _vm._v(" "), _c('div', {
          staticStyle: {
            "width": "80%",
            "padding": "10px 17%"
          }
        }, [_c('el-checkbox-group', {
          model: {
            value: (_vm.change_staff),
            callback: function($$v) {
              _vm.change_staff = $$v
            },
            expression: "change_staff"
          }
        }, _vm._l((item3.staffList), function(item4) {
          return _c('el-checkbox', {
            key: item4.id,
            attrs: {
              "label": item4.id
            }
          }, [_vm._v(_vm._s(item4.staff_name))])
        }), 1)], 1)], 2)
      }), 1)], 1)], 2)
    }), 1)], 1)], 2)
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "45%",
      "margin-top": "10px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Save()
      }
    }
  }, [_vm._v("确定")])], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e8e0724","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/znpb/KqzGl/KqzGl_add_setStaff.vue
// module id = null
// module chunks = 